var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlidingPuzzleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    stroke: "#CCC62A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 8C6.5 7.17157 7.17157 6.5 8 6.5H12.8333V12.8333H6.5V8ZM8 7.5C7.72386 7.5 7.5 7.72386 7.5 8V11.8333H11.8333V7.5H8Z",
    fill: "#CCC62A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8333 6.5H18.1666V12.8333H11.8333V6.5ZM12.8333 7.5V11.8333H17.1666V7.5H12.8333Z",
    fill: "#CCC62A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1667 6.5H22.0001C22.8285 6.5 23.5001 7.17157 23.5001 8V12.8333H17.1667V6.5ZM18.1667 7.5V11.8333H22.5001V8C22.5001 7.72386 22.2762 7.5 22.0001 7.5H18.1667Z",
    fill: "#CCC62A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 11.833H12.8333V18.1663H6.5V11.833ZM7.5 12.833V17.1663H11.8333V12.833H7.5Z",
    fill: "#CCC62A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 17.167H12.8333V23.5003H8C7.17157 23.5003 6.5 22.8288 6.5 22.0003V17.167ZM7.5 18.167V22.0003C7.5 22.2765 7.72386 22.5003 8 22.5003H11.8333V18.167H7.5Z",
    fill: "#CCC62A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8333 11.833H18.1666V18.1663H11.8333V11.833ZM12.8333 12.833V17.1663H17.1666V12.833H12.8333Z",
    fill: "#CCC62A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8333 17.167H18.1666V23.5003H11.8333V17.167ZM12.8333 18.167V22.5003H17.1666V18.167H12.8333Z",
    fill: "#CCC62A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1667 11.833H23.5001V18.1663H17.1667V11.833ZM18.1667 12.833V17.1663H22.5001V12.833H18.1667Z",
    fill: "#CCC62A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlidingPuzzleIcon);
export default __webpack_public_path__ + "static/media/slidingPuzzle_icon.fb0d85b1b5c9f91aa020128e2cf0effa.svg";
export { ForwardRef as ReactComponent };